__turbopack_context__.v({
  "pagination": "Pagination-module-scss-module__y7GTKq__pagination",
  "pagination__bullet": "Pagination-module-scss-module__y7GTKq__pagination__bullet",
  "pagination__bullet_active": "Pagination-module-scss-module__y7GTKq__pagination__bullet_active",
  "pagination__container": "Pagination-module-scss-module__y7GTKq__pagination__container",
  "timer-anim": "Pagination-module-scss-module__y7GTKq__timer-anim",
});
